import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { MARGIN_FLIGHT_COLUMN, MARGIN_FLIGHT_MODULE } from "../constants/marginFlightConstants";

export const setMarginPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: MARGIN_FLIGHT_MODULE,
        default_columns: MARGIN_FLIGHT_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });
